<template>
  <div class="blog-post">
    <section class="post">
      <div
        class="container"
        v-for="item in this.post"
        :value="item.id"
        :key="item.id"
      >
        <div class="post-header">
          <div class="post-title">
            <h1>{{ item.attributes.title }}</h1>
            <p class="published-in">
              {{ item.attributes.published_at | moment("DD, MMMM [de] YYYY") }}
            </p>
          </div>
          <img
            class="post-image_main"
            alt=""
            :src="item.attributes.banner_url"
          />
        </div>
        <div class="post-content" v-html="item.attributes.content"></div>
      </div>
    </section>

    <section class="news">
      <div class="container">
        <h2><span>Leia</span>Também</h2>
      </div>
      <div class="container container-news">
        <div
          class="box-news"
          v-for="item in this.posts"
          :value="item.id"
          :key="item.id"
        >
          <a :href="item.attributes.slug">
            <img class="news-image" alt="" :src="item.attributes.banner_url" />

            <h3>{{ item.attributes.title }}</h3>
          </a>

          <p>{{ item.attributes.description }}</p>

          <a :href="item.attributes.slug" class="read-more-button">
            Ler mais
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { blogService } from "@/services/blog.service";

export default {
  name: "BlogPost",
  data() {
    return {
      posts: [],
      post: [],
      currentPage: 1,
      perPage: 3
    };
  },

  mounted() {
    this.getPosts();
    this.showPost(this.$route.params.slug);
  },

  methods: {
    async getPosts() {
      try {
        const pagination = {
          perPage: this.perPage,
          page: this.currentPage
        };
        const posts = await blogService.listPosts(pagination);
        this.posts = posts.data.data.slice(0, 3);
      } catch (error) {
        console.log("Ocorreu um erro inesperado.");
      }
    },
    async showPost(slug) {
      try {
        const post = await blogService.getPost(slug);
        this.post = post.data;
        document.head.querySelector(
          "meta[name=description]"
        ).content = this.post.data.attributes.description;
      } catch (error) {
        console.log("Ocorreu um erro inesperado.");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.blog-post {
  padding: 0 0 100px;
  margin-top: 64px;

  .container {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    align-items: flex-start;

    &.container-news {
      max-width: 1200px;
      margin-top: 62px;
    }
  }

  h2 {
    font-size: var(--size-h2);
    line-height: 48px;
    color: var(--secundary-black);
    font-weight: 700;

    span {
      display: block;
      font-weight: 400;
      line-height: 32px;
    }
  }

  .divider {
    width: 95%;
    height: 2px;
    background: #c4c4c4;
    margin: 100px auto 20px;
  }

  .post {
    padding: 91px 0 0;

    .container {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }

    .post-header {
      max-width: 1200px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-bottom: 50px;

      .post-image_main {
        max-width: 60%;
        object-fit: cover;
        height: 385px;
        border-radius: 30px;
      }

      .post-title {
        background: var(--white);
        margin: -60px 0 0;
        padding: 48px 48px 48px 105px;
        border-radius: 0 20px 0 0;

        h1 {
          max-width: 619px;
          font-weight: 700;
          line-height: 60px;
          font-size: var(--size-title-post);
          color: var(--secundary-black);
          margin-bottom: 24px;
        }

        .published-in {
          font-weight: 400;
          padding: 0 0;
          color: var(--secundary-black);
        }
      }
    }

    // ul {
    //   padding: 0 0 0 105px;
    //   max-width: 1000px;
    //   margin: 0;
    //   list-style: none;
    //   li {
    //     line-height: 29px;
    //     margin-bottom: 16px;
    //   }
    // }
  }

  .news {
    padding: 100px 0 80px;
    background-color: var(--blue-custom);

    h2 {
      color: var(--white);
    }
  }

  .box-news {
    max-width: 380px;
    width: 100%;

    img {
      width: 100%;
      height: auto;
      margin-bottom: 30px;
      border-radius: 30px;
      height: 254px;
      object-fit: cover;
    }

    h3 {
      margin-bottom: 16px;
      font-weight: 700;
      line-height: 29px;
      font-size: var(--size-large);
      color: var(--white);
    }

    p {
      font-weight: 300;
      line-height: 29px;
      font-size: var(--size-large);
      color: var(--white);
      margin-bottom: 32px;
    }

    .read-more-button {
      text-decoration: none;
      color: var(--white);
      font-weight: 400;
    }
  }

  @media (max-width: 768px) {
    margin-top: 0;
    .post {
      padding: 80px 0 0;

      .post-header {
        max-width: 1200px;
        width: 100%;
        display: block;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 50px;

        .post-image_main {
          max-width: 100%;
          width: 100%;
        }

        .post-title {
          margin: 0;
          padding: 16px 0;
          border-radius: 0 0px 0 0;

          h1 {
            line-height: 46px;
            font-size: 36px;
            margin-bottom: 16px;
          }

          p {
            margin-bottom: 16px;
          }
        }
      }

      .post-content {
        padding: 20px;
      }

      p,
      h2,
      ul {
        padding: 0;
      }
    }

    .divider {
      margin: 20px auto 20px;
    }

    .news {
      padding: 50px 0 60px;

      .container {
        align-items: flex-start;
        flex-direction: column;

        &.container-news {
          margin-top: 32px;
          flex-direction: column;
        }
      }

      .box-news {
        margin-bottom: 60px;

        &:last-child {
          margin-bottom: 0px;
        }

        p {
          margin-bottom: 16px;
        }

        img {
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
